import { put, select } from "redux-saga/effects";

import type { TopicKnowledgeDataApplySearchCriteriaAction } from "domains/knowledgeData/actionTypes";
import { getKnowledgeDataSearchCriteria } from "domains/knowledgeData/selectors";
import { getTmSelectedId, getTmSelectedOuterNodeId } from "domains/transformationMap/selectors";
import { fetchKnowledgeDataForTopic } from "entities/knowledgeData/actions";

export function* applyKnowledgeDataSearchCriteriaSaga(action: TopicKnowledgeDataApplySearchCriteriaAction) {
  const searchCriteria: ReturnType<typeof getKnowledgeDataSearchCriteria> =
    yield select(getKnowledgeDataSearchCriteria);
  const tmSelectedId: ReturnType<typeof getTmSelectedId> = yield select(getTmSelectedId);
  const secondaryTopicId: ReturnType<typeof getTmSelectedOuterNodeId> = yield select(getTmSelectedOuterNodeId);

  const id = action.payload?.topicId ?? tmSelectedId;
  if (id !== undefined) yield put(fetchKnowledgeDataForTopic({ ...searchCriteria, id, secondaryTopicId }, action.meta));
}
